import { FileReaderTemplatePayload, fileReaderPrefix, urlCombine } from 'ihub/common';
import { handleResponse, microServiceAPI, standardPost } from '../classes/http-helper-const';
import HttpResponseOptions from '../interface/http-response-options';

export class FileReaderHttpService {
	private getTemplatePath = 'GetTemplate';

	async getTemplate(
		fileReaderTemplatePayload: FileReaderTemplatePayload,
		options?: HttpResponseOptions
	) {
		const url = urlCombine(microServiceAPI, fileReaderPrefix, this.getTemplatePath);
		const response = await standardPost(url, fileReaderTemplatePayload);
		return await handleResponse(response, 'Get Template', fileReaderPrefix, options);
	}
}
